import {useMemo} from 'react';
import {ContractAmendment} from '../../../backend/interfaces/contract-amendment';
import {useUsersInfoCache} from '../../../hooks/use-users-info-cache';

/**
 * A custom hook to cache user information from contract amendments.
 */
export function useContractAmendmentsUsersCache(contractAmendments?: ContractAmendment[]) {
  const userIds = useMemo(() => contractAmendments?.map((ca) => ca.authorId), [contractAmendments]);

  return useUsersInfoCache(userIds);
}
